import React, { useEffect, useState } from "react"
import { editModeOn } from "../utilFunctions";
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import TextTruncate from "../utilsComponent/textTruncate.jsx";
import LoadingPage from "../reusableComponents/loader/loadingPage.jsx";
import ClaimWithoutPolicy from "./createClaimWithoutPolicy.jsx";
import AdvanceSearch from "../utilsComponent/advanceSearch.jsx";
import CreateClaim from "./createClaim.jsx";
import NoDataFound from "../utilsComponent/noDataFound.jsx";
import Form from 'react-bootstrap/Form';
import { functionalities } from "../consts.js";

const ClaimsIntimation = (props) => {
    const {roleDataCookie, productNames} = props
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false)
    const [showRadioSearch, setShowRadioSearch] = useState(false)
    const [claimIntimationLists, setClaimIntimationLists] = useState([])
    const [searchResultMode, setSearchResultMode] = useState(false)
    const [raiseClaim, setRaiseclaim] = useState(null);
    const [productID, setProductID] = useState(0)
    const [openDropDown, setOpenDropDown] = useState(false)
    const [cropList, setCropList] = useState([])
    const [perilList, setPerilList] = useState([])
    const navigate = useNavigate();
    const [loading, setLoading]=useState(false)
    const [claimWithoutPolicyPage,setClaimWithoutPolicyPage]=useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0);
    const [selectedPage, setSelectedPage] = useState(0)
    const [pageCount, setPageCount] = useState(0);
    const [currentItems, setCurrentItems] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(null);
    const defaultSearch = {
        product_name: "",
        search_type: { label: "Policy ID", value: 1 },
        search_type_value: "",
        state: "",
        district: "",
        mandal: "",
        village: "",
        pincode: "",
        crop_name: "",
        perilName: "",
        farmer_name: ""
    }
    const [searchFields, setsearchFields] = useState(defaultSearch)
    const radioCheck = (list,index) => {
        setRaiseclaim(list)
        setSelectedIndex(index)
        //setShowRadioSearch(true);
    };

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(claimIntimationLists.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(claimIntimationLists.length / itemsPerPage));
        setRaiseclaim(null);
        setSelectedIndex(null)
    }, [itemOffset, itemsPerPage, claimIntimationLists]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % claimIntimationLists.length;
        setItemOffset(newOffset);
        setSelectedPage(event.selected)
    };
    const itemPerChangeHandler = (count) => {
        setItemsPerPage(count)
        setItemOffset(0)
        setSelectedPage(0)
    }

    return (
        <div>
            <header>
                <h2 id = "heading-intimation" className="ms-4 d-flex text-dark">Claim Intimation</h2>
            </header>
            <hr />
            {claimWithoutPolicyPage&&(<ClaimWithoutPolicy
            roleDataCookie={roleDataCookie}
            claimWithoutPolicyPage={claimWithoutPolicyPage}
            setClaimWithoutPolicyPage={setClaimWithoutPolicyPage}
            raiseClaim={raiseClaim}
            searchFields={searchFields}
            setsearchFields={setsearchFields}
            cropList={cropList}
            perilList={perilList}
            setOpenDropDown={setOpenDropDown}
            setShowRadioSearch={setShowRadioSearch}
            productID={productID}
            productNames={productNames}
            setRaiseclaim={setRaiseclaim}
            ></ClaimWithoutPolicy>)}
            {!claimWithoutPolicyPage&&showRadioSearch  && raiseClaim !== null && raiseClaim !== undefined? (
           <CreateClaim 
           roleDataCookie={roleDataCookie}
           raiseClaim={raiseClaim}
           searchFields={searchFields}
           setsearchFields={setsearchFields}
           cropList={cropList}
           perilList={perilList}
           setOpenDropDown={setOpenDropDown}
           setShowRadioSearch={setShowRadioSearch}
           productID={productID}
           setRaiseclaim={setRaiseclaim}
           setSelectedIndex={setSelectedIndex}
            />) : null}
          {
            !claimWithoutPolicyPage&&!showRadioSearch && (
                <AdvanceSearch
                 roleDataCookie={roleDataCookie}
                 claimWithoutPolicyPage={claimWithoutPolicyPage}
                 setClaimWithoutPolicyPage={setClaimWithoutPolicyPage}
                 showAdvanceSearch={showAdvanceSearch}
                 loading={loading}
                 cropList={cropList}
                 setCropList={setCropList}
                 perilList={perilList}
                 setPerilList={setPerilList}
                 setList={setClaimIntimationLists}
                 searchFields={searchFields}
                 setsearchFields={setsearchFields}
                 setShowAdvanceSearch={setShowAdvanceSearch}
                 setLoading={setLoading}
                 setProductID={setProductID}
                 productID={productID}
                 setSearchResultMode={setSearchResultMode}
                 module="claim_intimation"
                 productNames={productNames}
                 defaultSearch={defaultSearch}
                 resetFields={{
                    state: "",
                    district: "",
                    mandal: "",
                    village: "",
                    pincode: "",
                    crop_name: "",
                    perilName: "",
                    farmer_name: "",
                    crop:""
                 }}/>
            )
          }
            {!claimWithoutPolicyPage&&!showRadioSearch ? <hr /> : null}
            {!claimWithoutPolicyPage&&(<>{!claimWithoutPolicyPage&&loading ? (<LoadingPage></LoadingPage>) : (
            (!showRadioSearch && currentItems && currentItems.length > 0) ?
                <section className="p-4 table-responsive">
                    <div className="d-flex justify-content-between">
                        <h5>{searchResultMode && 'Search Results'} ({claimIntimationLists.length})</h5>
                        {editModeOn(functionalities.CLAIM_CREATION) && <button className="btn btn-success" onClick={() => {setOpenDropDown(false);setShowRadioSearch(true);setShowAdvanceSearch(false)}} disabled={!raiseClaim}>Claim</button>}
                    </div>
                    <div>
                    <table className="table table-strip mt-3 text-left">
                        <thead>
                            <tr>
                                { editModeOn(functionalities.CLAIM_CREATION) && <th scope="col">Select</th>}
                               
                                <th scope="col">Policy Number</th>
                                <th scope="col">Transaction ID</th>
                                <th scope="col">Farmer Name</th>
                                <th scope="col">Crop Name</th>
                                <th scope="col">Perils</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Farmer ID</th>
                                <th scope="col">State</th>
                                <th scope="col">District</th>
                                <th scope="col">Mandal</th>
                                <th scope="col">Survey Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentItems && currentItems.length > 0 && currentItems.map((list,index) => (
                                    <tr key={index}>
                                        {editModeOn(functionalities.CLAIM_CREATION) && (
                                            <td>
                                                <input
                                                    type="radio"
                                                    style={{ cursor: "pointer", width: "15px", height: "15px" }}
                                                    key={index}
                                                    name="create_claim_radio"
                                                    onClick={() => { radioCheck(list,index) }}
                                                    checked={selectedIndex === index}>
                                                </input>
                                            </td>
                                        )}
                                        <td>{list.policy_number}</td>
                                        <td>{list.tran_id}</td>
                                        <td>{list.customer_name}</td>
                                        <td>{list.crop_name ? <TextTruncate text={list.crop_name} length={17} /> : "--"}</td>
                                        <td>{list.perils ? <TextTruncate text={list.perils.join(",")} length={17} /> : "--"}</td>
                                        <td>{list.customer_mobile_number}</td>
                                        <td>{list.farmer_id}</td>
                                        <td>{list.policy_state_name}</td>
                                        <td>{list.policy_district_name}</td>
                                        <td>{list.policy_mandal_name}</td>
                                        <td>{list.survey_number}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    {
                        claimIntimationLists.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                                <div className="d-flex">
                                    Select Limit :
                                    <Form className="ms-3">
                                        {['radio'].map((type) => (
                                            <div key={`inline-${type}`} className="mb-3">
                                                <Form.Check
                                                    inline
                                                    label="10"
                                                    name="group1"
                                                    type={type}
                                                    //checked={itemsPerPage == 10}
                                                    //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                                                    id={`inline-${type}-1`}
                                                >
                                                    <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)} checked={itemsPerPage == 10} />
                                                    <Form.Check.Label >10</Form.Check.Label>
                                                </Form.Check>
                                                <Form.Check
                                                    inline
                                                    //label="25"
                                                    name="group1"
                                                    type={type}
                                                    //checked={itemsPerPage == 25}
                                                    //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                                                    id={`inline-${type}-2`}
                                                >
                                                    <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)} checked={itemsPerPage == 25} />
                                                    <Form.Check.Label >25</Form.Check.Label>
                                                </Form.Check>
                                                <Form.Check
                                                    inline
                                                    label="50"
                                                    name="group1"
                                                    type={type}
                                                    //checked={itemsPerPage == 50}
                                                    //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                                                    id={`inline-${type}-3`}
                                                >
                                                    <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)} checked={itemsPerPage == 50} />
                                                    <Form.Check.Label >50</Form.Check.Label>
                                                </Form.Check>
                                            </div>
                                        ))}
                                    </Form>
                                </div>
                                <ReactPaginate
                                    nextLabel=">>"
                                    onPageChange={(e) => handlePageClick(e)}
                                    pageRangeDisplayed={3}
                                    marginPagesDisplayed={2}
                                    pageCount={pageCount}
                                    forcePage={selectedPage}
                                    previousLabel="<<"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    renderOnZeroPageCount={null}
                                />
                            </div>
                        )
                    }
                    </div>
                </section> : <div className="text-center mt-5">
                    {!showRadioSearch ? <NoDataFound text="No Data Found"/> : null}                 
                    </div>
            )}
            </>)}
        </div>
    )
};

export default ClaimsIntimation;